/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BisacPayloadModel model module.
 * @module model/BisacPayloadModel
 * @version v1.0.0
 */
class BisacPayloadModel {
    /**
     * Constructs a new <code>BisacPayloadModel</code>.
     * @alias module:model/BisacPayloadModel
     * @param name {String} Name (required)
     */
    constructor(name) { 
        
        BisacPayloadModel.initialize(this, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name) { 
        obj['name'] = name;
    }

    /**
     * Constructs a <code>BisacPayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BisacPayloadModel} obj Optional instance to populate.
     * @return {module:model/BisacPayloadModel} The populated <code>BisacPayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BisacPayloadModel();

            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('mainId')) {
                obj['mainId'] = ApiClient.convertToType(data['mainId'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * Code
 * @member {String} code
 */
BisacPayloadModel.prototype['code'] = undefined;

/**
 * Foreign Key
 * @member {String} mainId
 */
BisacPayloadModel.prototype['mainId'] = undefined;

/**
 * Name (required)
 * @member {String} name
 */
BisacPayloadModel.prototype['name'] = undefined;

/**
 * seq
 * @member {Number} seq
 */
BisacPayloadModel.prototype['seq'] = undefined;






export default BisacPayloadModel;

